import {http} from "Services/Http/HttpClient";

export const deleteChildren = async(ids: string[]) : Promise<any> => {
    return http.delete('/children', {
        data: {
            ids: ids
        }
    })
}
